// Document types list
import {List, Map} from "immutable";

export const documentTypes = new List([
    new Map({
        type: -1,
        desc: 'Selecciona una tipo de documento'
    }),
    new Map({
        type: 'sales_invoice',
        desc: 'Facturas de venta'
    }),
    new Map({
        type: 'issue',
        desc: 'Albaranes de venta'
    }),
    new Map({
        type: 'sales_order',
        desc: 'Pedidos de venta'
    }),
    new Map({
        type: 'quote',
        desc: 'Presupuestos de venta'
    }),
    new Map({
        type: 'cost_breakdown',
        desc: 'Escandallos de venta'
    }),
    new Map({
        type: 'customer',
        desc: 'Clientes'
    }),
    new Map({
        type: 'purchase_invoice',
        desc: 'Facturas de compra'
    }),
    new Map({
        type: 'receipt',
        desc: 'Albaranes de compra'
    }),
    new Map({
        type: 'purchase_order',
        desc: 'Pedidos de compra'
    }),
    new Map({
        type: 'supplier',
        desc: 'Proveedores'
    }),
    new Map({
        type: 'employee',
        desc: 'Empleados'
    }),
    new Map({
        type: 'warehouse',
        desc: 'Almacenes'
    })
]);



// WEBPACK FOOTER //
// ./src/components/common/document_types.js